<template functional>
  <div :class="[
    'card',
    'content-card',
    'shadow',
    data.class,
    data.staticClass
  ]">
    <div class="card-body p-4">
      <slot name="title">
        <h4 v-if="props.title" class="mb-3">{{ props.title }}</h4>
      </slot>

      <div class="card-text">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
};
</script>

<style>
.content-card + .content-card {
  margin-top: 2rem !important;
}
</style>
